import Img from '@/components/base/Img';
import MaterialPlaque, { type PlaqueVariant } from '@/components/base/MaterialPlaque';

// Surface swatch sampled from each project's cover facade.
const plaqueBySlug: Record<string, PlaqueVariant> = {
  'chalk-house': 'chalk',
  'courtyard-residence': 'clay',
  'north-facade': 'sandstone',
  'weathered-lime-cottage': 'limewash',
  'stone-facade-house': 'honey',
  'linear-house': 'mineral-grey',
};

interface Props {
  src: string;
  srcSm?: string;
  sizes?: string;
  alt: string;
  slug?: string;
  className?: string;
}

// Project image with the MATERA plaque revealed on hover / keyboard focus of the parent `.group` link.
export default function ProjectImage({ src, srcSm, sizes = '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw', alt, slug, className = '' }: Props) {
  const variant = (slug && plaqueBySlug[slug]) || 'chalk';
  const srcSet = srcSm ? `${srcSm} 800w, ${src} 1400w` : undefined;
  return (
    <div data-sw-mask className="relative overflow-hidden">
      <Img src={srcSm || src} srcSet={srcSet} sizes={sizes} alt={alt} className={className} />
      <div className="plaque-overlay" aria-hidden="true">
        <MaterialPlaque size="sm" variant={variant} />
      </div>
    </div>
  );
}